module.exports = __webpack_public_path__ + "img/checked.8d092509.svg";